import {
  ADMIN_MY_PRODUCTS_3DMODAL,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH,
  ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2,
  PRODUCT_SETUP,
  REQUESTS_ROUTE,
  REQUEST_DETAIL_ROUTE,
} from '../constants/routePathConstants';
import {
  addOneMonthAddCurrentYear,
  clearCacheFromAPI,
  createModelAutomationRender,
  get3DModelProductAndTextureStatus,
  get3DModelProductJobStatus,
  getBrandName,
  getDownloadAndCollect3DFileAction,
  getTextSubstring,
  getThumbnailCardTagList,
  isARJob,
  isImageJob,
  isViewerJob,
  regenrateContentDialog,
  wait,
  windowOpen,
} from '../helpers/jsHelper';
import { LIVE_FURNISH } from '../constants/projectConstants';
import {
  MODEL_TYPES,
  REQUEST_STATUSES,
  STATUS_DONE_KEY,
  STATUS_FAILED_KEY,
  STATUS_INFECTED_KEY,
} from '../constants/constants';
import ThumbnailCardUI from './ThumbnailCardUI';
import ThumbnailCardV2, { ACTION } from './ThumbnailCardV2';
import { dispatcher } from '../helpers/projectHelper';
import { paginatedProductActions } from '../redux/slicers/admin/paginatedProductSlicer';
import { selectPropDetailsPopupData } from '../redux/slicers/propDetailsPopupSlicer';
import { useProductActions } from '../hooks/useProductActions';
import { useDispatch, useSelector } from 'react-redux';
import { useUserContext } from '../contexts/UserContext';
import { ModelIcon, TrashV2Icon } from '../assets/icons';
import { RestoreIcon } from '../components/icons/RestoreIcon';
import { useMemo, useState } from 'react';
import { discardPendingUpload } from '../helpers/resumableModelUpload';
import Button from '../components/Button';
import {
  apiDeleteUpload3DModel,
  apiHomeGetProp,
  apiUpdateProductV2GenerateStatus,
} from '../helpers/api';
import { errorToast, successToast, warningToast } from '../helpers/toastHelper';
import {
  MODEL_UPLOAD_TYPE,
  upload3DModelProductActions,
} from '../redux/slicers/upload3DModelProductSlicer';
import { usePermissionsHandler, useStaticPermissions } from '../hooks/usePermissions';
import { PERMISSION } from '../constants/permissionConstants';
import useCurrentOrganizationInfo from '../hooks/useCurrentOrganizationInfo';
import { textureDetailsModalActions } from '../redux/slicers/textureDetailsModalSlicer';
import Loader from './Loader';
import { useInfoDialogaActions } from '../hooks/useInfoDialogaActions';
import Switch from '../components/admin/switch';
import { Mixpanel, MxEvent } from './Mixpanel';
import { isCuratorPage } from '../helpers/urlHelper';
import { history } from '../history';
import { useNavigate } from 'react-router-dom';
import { setGenerateVisualModal } from '../redux/slicers/productV2Slicer';
export const ThumbnailCardProduct = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  hideOrg = false,
  to,
  hideFavourite,
  onEdit,
  onEditInfo,
  modelType = MODEL_TYPES.PRODUCT,
  designV2,
  ...rest
}) => {
  const navigate = useNavigate();
  const {
    favouriteLoading,
    onFavouriteToggle,
    onShare,
    addToCollection,
    onEdit: _onEdit,
    onEditInfo: _onEditInfo,
    requestTo3DFilesCollection,
    downloadLoading,
    download3DFilesZip,
    onRestore,
    onArchive,
    onSoftDelete,
    onSoftDeleteRestore,
  } = useProductActions({
    item: data,
    modelType,
    refetchList: rest?.refetchList,
  });

  const { handlePermissionEvent } = usePermissionsHandler();
  const { hasPermission } = useStaticPermissions();
  const {
    currentUser,
    isEditor,
    canDownload3DFile,
    canCreatePropGroup,
    updateUserData,
    isGuestUser,
  } = useUserContext();
  const { isFreemiumOrSelfServeUser } = useCurrentOrganizationInfo();
  const handleEdit = onEdit || _onEdit;
  const handleEditInfo = onEditInfo || _onEditInfo;

  const propsClicked = useSelector(selectPropDetailsPopupData);
  const highlight = data.id === propsClicked?.id ? 'info' : undefined;
  const secondLine =
    (data?.owner_organization_details?.id !== LIVE_FURNISH.id &&
      data?.owner_organization_details?.name) ||
    '';

  const brandTag = hideOrg ? '' : getBrandName(data?.owner_organization_details);
  const isArchived = data?.is_archived;

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const canCreateDimension = hasPermission(PERMISSION.DIMENSION_SHOT);
  const thumbnail =
    !data?.thumbnail && data?.base_model_details?.thumbnail
      ? data?.base_model_details?.thumbnail
      : data?.thumbnail;

  const handleDelete = async (e, { reupload = true } = {}) => {
    e?.stopPropagation?.();
    if (!data?.id || isGuestUser()) return;
    setDeleteLoading(true);
    clearCacheFromAPI();
    const response = await apiDeleteUpload3DModel(data?.id);
    setDeleteLoading(false);
    if (!response || !response?.status) {
      errorToast(response?.message || 'Unable to delete the model. Please try again.');
      return;
    }

    // The entry is gone — drop any leftover resumable record for it from IndexedDB
    // (no-op if there isn't one) so resume never tries to re-upload a discarded model.
    discardPendingUpload(data?.id);

    rest?.refetchList?.();
    successToast(`Model "${getTextSubstring(data?.name)}" deleted successfully.`);
    if (reupload) {
      handlePermissionEvent(PERMISSION.CAN_UPLOAD_3D_MODEL, () => {
        updateUserData();
        dispatcher(upload3DModelProductActions.show(MODEL_UPLOAD_TYPE.REQUEST));
      })();
    }
  };

  // Show "Discard & Re-upload" when the entry is owned and either:
  //  - a job ran and failed/got infected, OR
  //  - it's an incomplete upload (model entry created but no job yet — product_job_status === null).
  const showUpload3DModelDeleteButton =
    currentUser?.organization === data?.owner_organization &&
    data?.product_job_status !== null &&
    [STATUS_FAILED_KEY, STATUS_INFECTED_KEY].includes(data?.product_job_status);

  const ShowUpload3DModelDeleteUI = () => {
    if (!showUpload3DModelDeleteButton) return null;
    return (
      <div
        className="d-flex justify-content-center align-items-center gap-2 position-absolute w-100 h-100"
        style={{ background: 'rgba(0,0,0,0.1)', zIndex: 10 }}>
        <Button
          style={{
            boxShadow: '0px 0px 10px 0px rgba(0,0,0,0.25)',
          }}
          size="xs"
          disabled={deleteLoading}
          loading={deleteLoading}
          onClick={handleDelete}>
          Discard & Re-upload
        </Button>
      </div>
    );
  };

  const requestId = data?.request_details?.id;
  const requestStatus = data?.request_details?.status;
  const isRequestOrgAndCurrentOrgSame =
    data?.request_details?.organization === currentUser?.organization;

  const isProductRequestPending = [
    REQUEST_STATUSES.FEEDBACK.value,
    REQUEST_STATUSES.FOR_APPROVAL.value,
  ].includes(requestStatus);

  const canAccessV2Page = isGuestUser() || hasPermission(PERMISSION.PRODUCT_PAGE_V2);
  const isV2 = () =>
    canAccessV2Page && (!data?.product_page_version || data?.product_page_version === '2');

  const productJobStatus = useMemo(
    () =>
      isV2()
        ? get3DModelProductAndTextureStatus({
            data,
            isV2: isV2(),
          })
        : get3DModelProductJobStatus(data?.product_job_status),
    [data, canAccessV2Page]
  );

  const isContentGenerated = useMemo(
    () =>
      [
        data?.generate_ar_content_status,
        data?.generate_360_content_status,
        data?.generate_images_content_status,
      ].includes(STATUS_DONE_KEY) && data?.has_content,
    [data]
  );

  const isDeletedRequest = data?.is_delete_on_expire;
  const isExpiredItem = false;
  // const isExpiredItem = data?.is_customer_product_expired
  const dispatch = useDispatch();

  const _tagList = useMemo(() => getThumbnailCardTagList(data, isV2()), [data]);

  if (canDownload3DFile && modelType === MODEL_TYPES.PRODUCT && !isProductRequestPending) {
    // generating download & collect 3d files
    rest.customActions = getDownloadAndCollect3DFileAction({
      actions: rest.customActions,
      data,
      rest,
      designV2,
      download3DFilesZip,
      requestTo3DFilesCollection,
      onUpdate: (updatedData) => dispatcher(paginatedProductActions.update(updatedData)),
    });
  }

  // Hiding Open 3D File button for product
  if (data?.prop_data_user_file) {
    rest.customActions = {
      ...(rest.customActions || {}),
      [ACTION.MODEL_VIEWER_3D]: {
        label: '3D Viewer',
        icon: ModelIcon,
        onClick: () => {
          const URL =
            process.env.REACT_APP_3D_MODEL_VIEWER__APP_URL + '#model=' + data?.prop_data_user_file;
          windowOpen(URL, '_blank');
        },
      },
    };
  }

  if (
    data?.is_prop_group &&
    !isFreemiumOrSelfServeUser &&
    (modelType === MODEL_TYPES.PRODUCT ||
      modelType === MODEL_TYPES?.THREEDMODELS ||
      modelType === MODEL_TYPES.PRODUCT) &&
    (canCreatePropGroup() || +data?.created_by === +currentUser?.user?.id)
  ) {
    if (!rest?.isCollectionItem && !rest?.isSharedItem) {
      rest.customActions = {
        [ACTION.ARCHIVE]: {
          label: isGuestUser() ? 'Delete' : 'Archive',
          icon: designV2 ? TrashV2Icon : <TrashV2Icon />,
          onClick: isGuestUser() ? onSoftDelete : onArchive,
        },
        ...(rest?.customActions || {}),
      };
    }
    if (isArchived) {
      rest.customActions = {
        [ACTION.RESTORE]: {
          label: 'Restore',
          icon: designV2 ? RestoreIcon : <RestoreIcon />,
          onClick: onRestore,
        },
      };
    }
  }

  if (isArchived) {
    rest.customActions = {
      ...rest.customActions,
      [ACTION.RETRY]: { onClick: null },
      [ACTION.RAISE_TICKET]: { onClick: null },
      [ACTION.DOWNLOAD]: { onClick: null },
      [ACTION.EDIT]: { onClick: null },
      [ACTION.SHARE]: { onClick: null },
      [ACTION.ADD_TO_COLLECTION]: { onClick: null },
      [ACTION.DELETE]: { onClick: null },
      [ACTION.EDIT_INFO]: { onClick: null },
      [ACTION.INFO]: { onClick: null },
      [ACTION.DOWNLOAD_3D_FILES]: { onClick: null },
      [ACTION.COLLECT_3D_FILES]: { onClick: null },
      [ACTION.GENERATE_DIMENSION_SHOT]: { onClick: null },
      [ACTION.ARCHIVE]: { onClick: null },
    };
  }

  const redirectURL =
    isProductRequestPending && isRequestOrgAndCurrentOrgSame
      ? REQUEST_DETAIL_ROUTE.replace(':id', requestId)
      : !isArchived
        ? isV2()
          ? ADMIN_MY_PRODUCTS_3DMODAL_EACH_V2?.replace(':id', data?.id)
          : isEditor
            ? `${ADMIN_MY_PRODUCTS_3DMODAL}/${data?.id}`
            : null
        : null;

  const onCardClick = async () => {
    Mixpanel.track(true, MxEvent.CLICK_MODEL, {
      model_id: data?.id,
      model_name: data?.name,
      source: isCuratorPage() ? 'Curator' : 'Model',
      recent_files: 'No',
    });

    // When the user has the tag list with request status and request ID available, redirect to the request details page.
    if (
      _tagList?.length &&
      data?.request &&
      data?.request_details?.id &&
      data?.request_details?.status !== REQUEST_STATUSES.LIVE_ON_APP.value
    ) {
      const isRequestOrgAndCurrentOrgSame =
        +data?.request_details?.organization === +currentUser?.organization;
      if (isRequestOrgAndCurrentOrgSame) {
        navigate(`${REQUESTS_ROUTE}/${data?.request || data?.request_details?.id}`);
      } else {
        if (isEditor && modelType === MODEL_TYPES.THREEDMODELS) {
          handleEditInfo();
        } else {
          const message = data?.request_details?.organization_name
            ? `This request is in ${data?.request_details?.organization_name} org. Please switch to view.`
            : `This request belongs to another organization. Please switch to view.`;
          warningToast(message);
        }
      }
      return;
    }

    if (!isV2() && data) {
      window.open(`${ADMIN_MY_PRODUCTS_3DMODAL}/${data?.id}`, '_blank');
      return;
    }

    // This code block handles the logic for opening a 3D model experience page or displaying a warning message if the experience page is not created.
    // If the `data` object has no content and the application is in V2 mode, and the user is not a guest user or is an editor, the code checks if the 3D model has content generated.
    // If the content is generated, it updates the `data` object with the `has_content` flag set to `true` and opens the redirected URL in a new tab.
    // If the content is not generated, it dispatches an action to show the texture details modal.
    // If the redirected URL is not available, it displays a warning toast message indicating that the experience page is not created. Otherwise, it opens the redirected URL in a new tab.
    if (!data?.has_content && isV2() && (!isGuestUser() || isEditor)) {
      const hasContentGenerated = (await apiHomeGetProp(data?.id))?.results?.[0]?.has_content;
      if (hasContentGenerated) {
        dispatch(paginatedProductActions.update({ ...data, has_content: true }));
        window.open(redirectURL, '_blank');
        return;
      }
      dispatch(textureDetailsModalActions.generateContentShowModal(data));
    } else {
      if (!redirectURL) {
        warningToast('Experience page is not created.');
      } else window.open(redirectURL, '_blank');
    }
  };

  /*
    `onFavouriteToggle` is curried - onFavouriteToggle(item) hands back the handler,
    it does not perform the toggle. Calling only the outer half built a function and
    dropped it, so the click cleared the cache and did nothing else. Every other card
    passes the inner function straight to onFavouriteChange; this does the same, and
    forwards the event, which the toggle reads `target.checked` from.
  */
  const onFavoritesToggle = (info) => (event) => {
    clearCacheFromAPI();
    return onFavouriteToggle(info)(event);
  };

  const _onFavouriteChange = !thumbnail && data.is_prop_group ? null : onFavoritesToggle(data);
  const _hideFavourite =
    (!thumbnail && data.is_prop_group) || hideFavourite || productJobStatus;
  const _onSelect = isDeletedRequest
    ? onSelect
    : !isGuestUser() && ((!thumbnail && data.is_prop_group) || _tagList?.length > 0)
      ? null
      : onSelect;

  const titleProps =
    isArchived || productJobStatus
      ? null
      : {
          onClick: () => handleEdit(_tagList),
        };
  if (MODEL_TYPES.THREEDMODELS === modelType) {
    // if (isFreemiumOrSelfServeUser && modelType === MODEL_TYPES?.THREEDMODELS) {
    // if (!rest?.isCollectionItem && !rest?.isSharedItem) {
    //   rest.customActions = {
    //     [ACTION.ARCHIVE]: {
    //       label: 'Delete',
    //       icon: designV2 ? TrashV2Icon : <TrashV2Icon />,
    //       onClick: (id) => onSoftDelete(id, { is_delete_on_expire: true }),
    //     },
    //     ...(rest?.customActions || {}),
    //   };
    // }
    //}
    if (
      currentUser?.role?.is_owner ||
      currentUser?.role?.is_admin ||
      currentUser?.user.id === data?.created_by ||
      isGuestUser()
    ) {
      rest.customActions = {
        [ACTION.ARCHIVE]: {
          label: 'Delete',
          icon: designV2 ? TrashV2Icon : <TrashV2Icon />,
          onClick: (id) => onSoftDelete(id, { is_delete_on_expire: true }),
        },
        ...(rest?.customActions || {}),
      };
      if (isDeletedRequest) {
        rest.customActions = {
          [ACTION.RESTORE]: {
            label: 'Restore',
            icon: designV2 ? RestoreIcon : <RestoreIcon />,
            onClick: (id) => onSoftDeleteRestore(id, { is_delete_on_expire: false }),
          },
        };
      }
    }
  }

  if (isGuestUser()) {
    const isSameOrg = currentUser?.organization === data?.owner_organization;
    const deleteActions = !isSameOrg
      ? {
          [ACTION.DELETE]: { onClick: null },
          [ACTION.ARCHIVE]: { onClick: null },
        }
      : { [ACTION.DELETE]: { onClick: isDeletedRequest ? onSoftDelete : null } };
    rest.customActions = {
      ...rest.customActions,
      [ACTION.RETRY]: { onClick: null },
      [ACTION.RAISE_TICKET]: { onClick: null },
      [ACTION.DOWNLOAD]: { onClick: null },
      [ACTION.EDIT]: { onClick: null },
      [ACTION.SHARE]: { onClick: null },
      [ACTION.ADD_TO_COLLECTION]: { onClick: null },
      [ACTION.EDIT_INFO]: { onClick: null },
      [ACTION.INFO]: { onClick: null },
      [ACTION.DOWNLOAD_3D_FILES]: { onClick: null },
      [ACTION.COLLECT_3D_FILES]: { onClick: null },
      [ACTION.RESTORE]: { onClick: null },
      ...deleteActions,
    };
  }

  const handleClickProductSetup = () => {
    history.push(PRODUCT_SETUP.replace(':id', data.id));
  };
  if (!isV2() || isArchived) {
    rest.customActions = {
      ...rest.customActions,
      [ACTION.GENERATE_CONTENT]: { onClick: null },
      // [ACTION.GENERATE_DIMENSION_SHOT]: { onClick: null },
    };
  }

  if (
    isV2() &&
    isContentGenerated &&
    !_tagList?.find(({ label }) => label?.toLowerCase() === 'generating visuals') &&
    !_tagList?.find(({ label }) => label?.toLowerCase() === 'view visuals')
  ) {
    _tagList.push({
      type: 'pending',
      label: 'View visuals',
    });
  }

  return (
    <>
      {loading ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 2000,
            background: 'rgba(0,0,0,0.3)',
            height: '100vh',
            width: '100vw',
          }}>
          <Loader loading={loading} />
        </div>
      ) : null}
      {designV2 ? (
        <ThumbnailCardV2
          id={data?.id}
          onFavouriteChange={_onFavouriteChange}
          onSelect={_onSelect}
          modelType={modelType}
          selected={selected}
          isFavourite={data.is_favourite}
          hideFavourite={_hideFavourite}
          favouriteLoading={favouriteLoading}
          titleProps={isGuestUser() ? null : titleProps}
          openDetails={null}
          onCardClick={!isArchived ? onCardClick : null}
          // redirect={modelType === MODEL_TYPES.THREEDMODELS && !isArchived}
          // redirectURL={redirectURL}
          // redirectTarget={modelType === MODEL_TYPES.PRODUCT ? null : '_self'}
          data={data}
          userCard={MODEL_TYPES.THREEDMODELS === modelType}
          name={data?.name}
          thumbnail={thumbnail}
          date={data.created_at}
          customActions={rest?.customActions}
          showCheckbox
          showCheckboxGuestUser={isGuestUser()}
          isFavouriteIcon
          brandTag={MODEL_TYPES.THREEDMODELS !== modelType && brandTag}
          dateLabel={
            isDeletedRequest && MODEL_TYPES.THREEDMODELS === modelType && data?.delete_expired_date
              ? `Permanently delete on ${addOneMonthAddCurrentYear(data?.delete_expired_date)}`
              : ''
          }
          onEdit={() => handleEdit(_tagList, true)}
          blurCard={isDeletedRequest || isExpiredItem ? 'blurCard' : undefined}
          onEditInfo={isEditor && modelType === MODEL_TYPES.PRODUCT ? handleEditInfo : null}
          fullWidth={fullWidth}
          highlight={highlight}
          onGenerateContent={
            isV2() &&
            (!isGuestUser() || isEditor) &&
            (() => onProductGenerateContent(data, setLoading, openInfoDialog, closeInfoDialog))
          }
          // && !data?.generate_images_content_status
          onGenerateDimension={
            canCreateDimension &&
            (!isGuestUser() || isEditor) &&
            (() => onGenerateDimesion(data, setLoading, openInfoDialog, closeInfoDialog))
          }
          // onClickProductSetup={
          //   handleClickProductSetup
          // }
          tagList={
            showUpload3DModelDeleteButton
              ? []
              : (isDeletedRequest || isExpiredItem) && MODEL_TYPES.THREEDMODELS === modelType
                ? [
                    {
                      type: 'deleteRequest',
                      label: isDeletedRequest ? 'Deletion requested' : 'Expired',
                    },
                  ]
                : _tagList
          }
          tagListStyle={
            (typeof productJobStatus === 'string' &&
              productJobStatus?.toLowerCase() === 'generating visuals') ||
            isContentGenerated
              ? {
                  right: 0,
                  bottom: 0,
                }
              : {}
          }
          tagListItemStyle={
            (typeof productJobStatus === 'string' &&
              productJobStatus?.toLowerCase() === 'generating visuals') ||
            isContentGenerated
              ? { textTransform: 'uppercase' }
              : {}
          }
          {...(isProductRequestPending
            ? {}
            : {
                onShare,
                onAddToCollection: addToCollection,
              })}
          {...rest}
          showMenu={
            !showUpload3DModelDeleteButton &&
            (productJobStatus === false ||
              (typeof productJobStatus === 'string' &&
                productJobStatus?.toLowerCase() === 'generating visuals'))
          }
          imageOverlay={<ShowUpload3DModelDeleteUI />}
        />
      ) : (
        <ThumbnailCardUI
          key={data.id}
          id={data.id}
          onGenerateContent={
            isV2() &&
            canCreateDimension &&
            (!isGuestUser() || isEditor) &&
            (() => onProductGenerateContent(data, setLoading, openInfoDialog, closeInfoDialog))
          }
          // && !data?.generate_images_content_status
          onGenerateDimension={
            canCreateDimension &&
            (!isGuestUser() || isEditor) &&
            (() => onGenerateDimesion(data, setLoading, openInfoDialog, closeInfoDialog))
          }
          to={isProductRequestPending ? null : to}
          onEdit={() => handleEdit(_tagList)}
          onEditInfo={isEditor && modelType === MODEL_TYPES.PRODUCT ? handleEditInfo : null}
          onCardImageClick={modelType === MODEL_TYPES.PRODUCT ? onCardClick : () => {}}
          thumbnail={thumbnail}
          images={data?.images}
          name={data.name}
          isFavourite={data.is_favourite}
          favouriteLoading={favouriteLoading}
          titleProps={titleProps}
          onFavouriteChange={_onFavouriteChange}
          size={size}
          fullWidth={fullWidth}
          onSelect={_onSelect}
          selected={selected}
          hideFavourite={_hideFavourite}
          data={data}
          highlight={highlight}
          secondLine={secondLine}
          brandTag={brandTag}
          tagList={_tagList}
          tagListStyle={
            (typeof productJobStatus === 'string' &&
              productJobStatus?.toLowerCase() === 'generating visuals') ||
            isContentGenerated
              ? {
                  right: 0,
                  bottom: 0,
                }
              : {}
          }
          tagListItemStyle={
            (typeof productJobStatus === 'string' &&
              productJobStatus?.toLowerCase() === 'generating visuals') ||
            isContentGenerated
              ? { textTransform: 'uppercase' }
              : {}
          }
          {...(isProductRequestPending
            ? {}
            : {
                onShare,
                onAddToCollection: addToCollection,
              })}
          {...rest}
        />
      )}
    </>
  );
};

export const ThumbnailCardModel3D = (props) => {
  return (
    <ThumbnailCardProduct
      {...props}
      modelType={MODEL_TYPES.THREEDMODELS}
      // to={props.to || ADMIN_MY_PRODUCTS_3DMODAL_EACH}
    />
  );
};

export const onProductGenerateContent = async (
  data,
  setLoading,
  openInfoDialog,
  closeInfoDialog
) => {
  async function generateContent(_data) {
    !data?.has_content && setLoading?.(true);
    const _isARJob = isARJob(_data);
    const _isViewerJob = isViewerJob(_data);
    const _isImageJob = isImageJob(_data);
    if (_isARJob || _isViewerJob || _isImageJob) {
      // We update the generation status only when re-generating content.
      // The three variables (_isARJob, _isViewerJob, _isImageJob) provide boolean values (true/false).
      // If none of these jobs are active, it indicates the first generation attempt,
      // and we do not want to update the status in that case.
      await apiUpdateProductV2GenerateStatus({
        id: data.id,
        data: {
          generate_ar_content_status: _isARJob ? 0 : 1,
          generate_images_content_status: _isImageJob ? 0 : 1,
          generate_360_content_status: _isViewerJob ? 0 : 1,
        },
      });
    }
    await createModelAutomationRender({
      data,
      arJob: _isARJob,
      viewerJob: _isViewerJob,
      imageJob: _isImageJob,
    });
    !data?.has_content && setLoading?.(false);
  }

  Mixpanel.track(true, MxEvent.CLICK_GENERATE_VISUAL);
  dispatcher(setGenerateVisualModal(data));
  // if (data?.has_content) {
  //   regenrateContentDialog({
  //     generateContent,
  //     openInfoDialog,
  //     closeInfoDialog,
  //     data,
  //     isModel: true,
  //   });
  // } else {
  //   generateContent(data);
  // }
};

export const onGenerateDimesion = async (data, setLoading, openInfoDialog, closeInfoDialog) => {
  setLoading?.(true);
  const _isImageJob = isImageJob(data);
  Mixpanel.track(true, MxEvent.CLICK_GENERATE_DIMENSION);
  await createModelAutomationRender({
    data,
    arJob: false,
    viewerJob: false,
    imageJob: _isImageJob,
    onlyDimensionRender: true,
    preventRedirection: true,
    showMessage: '',
  });
  setLoading?.(false);
  successToast('Dimension shot creation request has been successfully submitted.');
};
